export const actions = {
    GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
    GET_NOTIFICATIONS_SUCCESS: "GET_NOTIFICATIONS_SUCCESS",
    GET_NOTIFICATIONS_FAILURE: "GET_NOTIFICATIONS_FAILURE",
}